/*@ngInject*/
const BreadcrumbsRepository = function (baseSharedPromiseRepository) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadSubmissionBreadcrumbs = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/BreadCrumbs',
            cacheKey = 'submissionBreadcrumbs:' + submissionId;

        return this.get(cacheKey, url);
    };

    this.loadReportBreadcrumbs = function (externalReportId) {
        var url = '/rest/ExternalReport/' + externalReportId + '/BreadCrumbs',
            cacheKey = 'reportBreadcrumbs:'+externalReportId;

        return this.get(cacheKey, url);
    };

    this.loadQuoteBreadcrumbs = function (quoteId) {
        var url = '/rest/Quote/' + quoteId + '/breadCrumbs',
            cacheKey = 'quoteBreadcrumbs:' + quoteId;

        return this.get(cacheKey, url);
    };


    this.loadProposalBreadcrumbs = function (proposalId) {
        var url = '/rest/Proposal/' + proposalId + '/breadCrumbs',
            cacheKey = 'proposalBreadcrumbs:' + proposalId;
        return this.get(cacheKey, url);
    };

    this.loadPolicyIssuanceBreadcrumbs = function (policyIssuanceId) {
        var url = '/rest/PolicyIssuance/' + policyIssuanceId + '/breadCrumbs',
            cacheKey = 'policyIssuanceBreadcrumbs:'+policyIssuanceId;

        return this.get(cacheKey, url);
    };

    this.loadPolicyCancellationBreadcrumbs = function (policyCancellationId) {
        var url = '/rest/PolicyCancellation/' + policyCancellationId + '/breadCrumbs',
            cacheKey = 'policyCancellationBreadcrumbs:'+policyCancellationId;

        return this.get(cacheKey, url);
    };

    this.loadPolicyBreadcrumbs = function (policyId) {
        var url = '/rest/Policy/' + policyId + '/breadCrumbs',
            cacheKey = 'policyBreadcrumbs:'+policyId;
        return this.get(cacheKey, url);
    };

    this.loadEndorsementBreadcrumbs = function (endorsementId) {
        var url = '/rest/Endorsement/' + endorsementId + '/breadCrumbs',
            cacheKey = 'endorsementBreadcrumbs:'+endorsementId;

        return this.get(cacheKey, url);
    };

    this.loadPolicyRewriteBreadcrumbs = function (policyRewriteId) {
        var url = '/rest/PolicyRewrite/' + policyRewriteId + '/breadCrumbs',
            cacheKey = 'policyRewriteBreadcrumbs:'+policyRewriteId;

        return this.get(cacheKey, url);
    };
};

angular.module('gw-um-submission')
    .service('breadcrumbsRepository', BreadcrumbsRepository);
